import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter,
} from "@reduxjs/toolkit";
import { showLoader, hideLoader } from "store/misc/loaderSlice";
import wineClubService from "services/wineClubService";
import { setWinClub } from "./subscriptionSlice";

export const getWineClubs = createAsyncThunk("vino/wine-clubs", async () => {
	const wineClubs = await wineClubService.all();
	return wineClubs;
});

export const getWineClub = createAsyncThunk(
	"vino/wine-club/getWineClub",
	async (wineClubId, { dispatch, rejectWithValue }) => {
		try {
			dispatch(showLoader());
			const wineClub = await wineClubService.get(wineClubId);
			dispatch(setWinClub({ ...wineClub, id: wineClubId }));
			return wineClub;
		} catch (ex) {
			console.error(ex);
			return rejectWithValue(ex);
		} finally {
			dispatch(hideLoader());
		}
	}
);

const wineClubsAdapter = createEntityAdapter();

export const {
	selectAll: selectWineClubs,
	selectById: selectWineClubById,
} = wineClubsAdapter.getSelectors((state) => state.vino.wineClubs);

const wineClubsSlice = createSlice({
	name: "vino/wine-clubs",
	initialState: wineClubsAdapter.getInitialState({ data: null }),
	reducers: {
		resetWineClubs: (state) => wineClubsAdapter.removeAll(state),
	},
	extraReducers: {
		[getWineClubs.fulfilled]: wineClubsAdapter.setAll,
		[getWineClub.fulfilled]: (state, action) => {
			state.data = action.payload;
		},
	},
});

export const { resetWineClubs } = wineClubsSlice.actions;

export default wineClubsSlice.reducer;
